import type { ConditionalRuleTarget } from '../model/form-rules.store';
import type { FormElement, TableElement } from '../model/form.types';
import { iterateFormElements } from './form-element-traversal';

export function flattenRuleFields(elements: readonly FormElement[]) {
  return [...iterateFormElements(elements)];
}

export function getRuleFieldLabel(fields: readonly FormElement[], fieldId: string) {
  const field = fields.find((item) => item.id === fieldId);
  return field?.properties.label || field?.properties.name || 'Campo sem nome';
}

export function getRuleTargetOptions(
  elements: readonly FormElement[],
  fields: readonly FormElement[],
  triggerFieldId?: string
) {
  const targets: ConditionalRuleTarget[] = fields
    .filter((field) => field.id !== triggerFieldId)
    .map((field) => ({
      id: field.id,
      type: 'field',
      label: `${getRuleFieldLabel(fields, field.id)} (${field.id})`,
      fieldIds: [field.id],
    }));

  elements.forEach((element) => {
    if (element.type !== 'TABLE') return;

    const fieldIds = (element as TableElement).properties.cells
      .flatMap((row) => row.map((cell) => cell.content?.id).filter(Boolean))
      .filter((fieldId): fieldId is string => !!fieldId && fieldId !== triggerFieldId);

    if (fieldIds.length > 0) {
      targets.push({
        id: element.id,
        type: 'table',
        label: element.id,
        fieldIds,
      });
    }
  });

  return targets;
}
